import { Box, Chip } from "@mui/material";
import { formatNumber, sectorLabels } from "../roiUtils";
import { RoiState } from "../types";

interface RoiInputSummaryChipsProps {
  state: RoiState;
}

export default function RoiInputSummaryChips({ state }: RoiInputSummaryChipsProps) {
  const chips = [
    `Settore: ${sectorLabels[state.sector]}`,
    `Dipendenti: ${formatNumber(state.employees)}`,
    `Processi attivi: ${formatNumber(state.processes)}`,
    `Ore manuali totali: ${formatNumber(state.weeklyHours)} h/sett`,
    `Costo orario: ${formatNumber(state.hourlyCost)} EUR/h`,
    `Errori: ${formatNumber(state.monthlyErrors)} al mese`,
  ];

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
      {chips.map((label) => (
        <Chip
          key={label}
          label={label}
          variant="outlined"
          sx={{
            borderColor: "rgba(84, 189, 193, 0.5)",
            backgroundColor: "rgba(84, 189, 193, 0.08)",
            color: (theme) =>
              theme.palette.mode === "dark" ? "primary.main" : "secondary.main",
            fontWeight: 800,
            maxWidth: "100%",
            "& .MuiChip-label": {
              overflow: "hidden",
              textOverflow: "ellipsis",
            },
          }}
        />
      ))}
    </Box>
  );
}
